package com.iptvplayer.web.ui

import com.iptvplayer.shared.util.Constants

external fun encodeURIComponent(value: String): String

/** Holds the current access token so image/stream URLs can be proxied synchronously. */
object WebSession {
    var token: String? = null
    var userName: String? = null
}

/**
 * Route an `http://` resource (IPTV logo, cover, or stream) through the backend
 * proxy so the HTTPS page can load it. `https://` and relative URLs are returned
 * unchanged (no mixed-content issue).
 */
fun proxied(url: String): String {
    if (!url.startsWith("http://", ignoreCase = true)) return url
    val token = WebSession.token ?: ""
    return "${Constants.BASE_URL}/api/proxy?url=${encodeURIComponent(url)}&token=${encodeURIComponent(token)}"
}

fun proxiedOrNull(url: String?): String? = url?.let { proxied(it) }
